import { useEffect, useState } from 'react'
import type { MkCountry, MkState } from '@typescript'

export const useReference = () => {
  const [countries, setCountries] = useState<MkCountry[]>([])
  const [states, setStates] = useState<MkState[]>([])

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        // const response = await fetch('/api/countries')
        // const data = await response.json()
        const data = (await import('@data/form/countries.json')).default
        setCountries(data)
      } catch (error) {
        console.error('Failed to fetch countries:', error)
      }
    }

    const fetchStates = async () => {
      try {
        // const response = await fetch('/api/states')
        // const data = await response.json()
        const data = (await import('@data/form/states.json')).default
        setStates(data)
      } catch (error) {
        console.error('Failed to fetch states:', error)
      }
    }

    fetchCountries()
    fetchStates()
  }, [])

  return {
    countries,
    states,
  }
}
